import { createUseStyles } from 'react-jss';
import type { Theme } from '@wds/styles';

const useStyles = createUseStyles(
  ({ spacing, border, breakpoints, palette }: Theme) => ({
    wrapper: {
      textAlign: 'center',
      display: 'flex',
      justifyContent: 'center',
      padding: '150px 0',
    },
    messageWrapper: {
      minWidth: '550px',
      margin: 0,
      position: 'unset',
    },
    cardWrapper: {
      marginTop: spacing['4'],
    },
    linkList: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      margin: 0,
      padding: `${spacing['6']}px 10% 0`,
      listStyleType: 'none',

      '& > li': {
        flexGrow: 1,
        flexBasis: 'auto',
        textAlign: 'center',
        borderRight: border.border,
        backgroundColor: palette.text.light,

        '&:last-child': {
          borderRight: 'none',
        },
      },
    },
  })
);

export default useStyles;
